import React, { useState } from "react";
import {
  TIERS,
  ICONS,
  ELIGIBILITY,
  ELIGIBILITY_NOTES,
  BENEFITS,
  BENEFITS_TITLE,
  BENEFITS_INTRO,
  FOOTNOTE,
} from "./data";
import './style.scss';

// 官方网站链接：https://world.hyatt.com/content/gp/zh-hans/tiers-and-benefits.html
// 用于微信小程序webview展示：展示凯悦酒店的会员权益

const PAGE_TITLE = "会籍";

// 会籍图标，路径取自官网 be-icon 组件
const TierIcon = ({ name }) => (
  <svg className="tier-icon" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
    <path d={ICONS[name]} />
  </svg>
);

// 礼遇标题右侧的「查看权益详情」入口
const InfoIcon = () => (
  <svg className="info-icon" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
    <path d={ICONS.info} />
  </svg>
);

// 该级别提供此项礼遇
const CheckIcon = ({ color }) => (
  <svg className="check-icon" viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="12" fill={color} />
    <path d="M10.3 16.2 6.5 12.4l1.42-1.42 2.38 2.38 5.78-5.78L17.5 9z" fill="#fff" />
  </svg>
);

const SectionTitle = ({ children }) => (
  <h2 className="section-title"><span>{children}</span></h2>
);

// 资格：每个会籍级别一张卡片，展示达标所需的房晚或基本积分
const EligibilityCard = ({ tier }) => (
  <div className="card">
    <div className="card-header">
      <TierIcon name={tier.key} />
      <span className="card-header-name">{tier.name}</span>
    </div>
    <div className="card-body">
      <div className="row">
        <span className="row-label">房晚</span>
        <span className="row-value">{tier.nights}</span>
      </div>
      {tier.single ? (
        <div className="row">
          <span className="row-label">基本积分</span>
          <span className="row-value">{tier.nights}</span>
        </div>
      ) : (
        <>
          <div className="row-or"><span>或</span></div>
          <div className="row">
            <span className="row-label">基本积分</span>
            <span className="row-value">{tier.points}</span>
          </div>
        </>
      )}
    </div>
  </div>
);

// 礼遇：点击标题栏展开该项礼遇的详情说明
const BenefitCard = ({ benefit }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="card">
      <button
        type="button"
        className="card-header card-header-btn"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <span className="card-header-name">{benefit.name}</span>
        <InfoIcon />
      </button>

      {open && (
        <div className="benefit-detail">
          <p className="benefit-detail-title">{benefit.title || benefit.name}</p>
          <p className="benefit-detail-desc">{benefit.desc}</p>
          {benefit.bullets && (
            <ul className="benefit-detail-list">
              {benefit.bullets.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          )}
          {benefit.legal && <p className="benefit-detail-legal">{benefit.legal}</p>}
        </div>
      )}

      <div className="card-body benefits-info">
        {TIERS.map((tier, i) => {
          const value = benefit.values[i];
          return (
            <div className="row" key={tier.key}>
              <span className="row-label row-label-tier">{tier.name}</span>
              <span className="row-value">
                {value === true
                  ? <CheckIcon color={tier.color} />
                  : value === null ? <span className="row-value-none">--</span> : value}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default (props) => {

  return (
    <div>
      <h1 className="hotel-member-title">
      <img className="hotel-member-logo hyatt-logo" src="https://staticfile.badazhou.com/20260921/340908afeca43747bb67096ddc8ccfdd.png" alt="" />
      <span>凯悦天地-会员礼遇</span>
    </h1>

      <div className="wrapper hyatt-benefits">
        <SectionTitle>{PAGE_TITLE}</SectionTitle>

        {ELIGIBILITY.map(tier => <EligibilityCard key={tier.key} tier={tier} />)}

        <div className="notes">
          <p>房晚：{ELIGIBILITY_NOTES.nights}</p>
          <p>基本积分：{ELIGIBILITY_NOTES.points}</p>
        </div>

        <SectionTitle>{BENEFITS_TITLE}</SectionTitle>
        <p className="section-intro">{BENEFITS_INTRO}</p>

        {BENEFITS.map(benefit => <BenefitCard key={benefit.name} benefit={benefit} />)}

        <p className="footnote">{FOOTNOTE}</p>
      </div>
    </div>
  );
}
